import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FiLogOut, FiUser } from 'react-icons/fi';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between px-6 py-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            Witaj, {user?.username || 'Admin'}! 👋
          </h2>
          <p className="text-sm text-gray-600">
            Zarządzaj publikacjami na social media
          </p>
        </div>

        <div className="flex items-center space-x-4">
          {/* User Info */}
          <div className="flex items-center space-x-2 px-4 py-2 bg-gray-100 rounded-lg">
            <FiUser className="text-gray-600" />
            <span className="text-sm font-medium text-gray-700">
              {user?.username}
            </span>
            <span className="text-xs text-gray-500 bg-blue-100 px-2 py-1 rounded">
              {user?.role || 'admin'}
            </span>
          </div>

          {/* Logout Button */}
          <button
            onClick={logout}
            className="flex items-center space-x-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
          >
            <FiLogOut size={18} />
            <span>Wyloguj</span>
          </button>
        </div>
      </div>
    </header>
  );
}

